import { cn } from '@/lib/utils';

/**
 * Rounded violet tile holding an open tracking ring — the "O" of OLE-FLEET,
 * drawn as a location halo with a live pip seated in its gap.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 36 36" className={cn('size-9', className)} aria-hidden>
      <defs>
        <linearGradient id="ole-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--primary)" />
          <stop offset="100%" stopColor="color-mix(in oklch, var(--primary) 72%, black)" />
        </linearGradient>
      </defs>
      <rect width="36" height="36" rx="11" fill="url(#ole-mark)" />
      {/* Circumference is ~51.8, so 42 of dash leaves a ~68° gap at upper right. */}
      <circle
        cx="18"
        cy="18"
        r="8.25"
        fill="none"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeDasharray="42 9.9"
        className="stroke-primary-foreground"
      />
      <circle cx="24.7" cy="13.2" r="2.7" className="fill-moving" />
    </svg>
  );
}

export function Brand({ className }: { className?: string }) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <BrandMark />
      <span className="text-[16px] leading-none font-extrabold tracking-tight">
        OLE<span className="text-primary">-FLEET</span>
      </span>
    </span>
  );
}
